const randInt = (startNum: number, endNum: number): number => {
  return Math.floor(Math.random() * (endNum - startNum + 1)) + startNum
}

//ランダムな配列
const getRandomArray = (length: number, startNum: number = 0): Array<number> => {
  const returnArray = new Array<number>()

  for (var i = 0; i < length; i++) {
    var flag = true
    while (flag) {
      flag = false
      var rndNum = randInt(startNum, startNum + length - 1)
      for (var ii = 0; ii < i; ii++) {
        if (rndNum == returnArray[ii]) {
          flag = true
          break
        }
      }
    }
    returnArray[i] = rndNum
  }

  return returnArray
}

//配列をシャッフル
const shuffleArray = (array: Array<any>): Array<any> => {
  var n = array.length
  var t
  var i

  while (n) {
    i = Math.floor(Math.random() * n--)
    t = array[n]
    array[n] = array[i]
    array[i] = t
  }

  return array
}

const ArrayUtil = {
  randInt: randInt,
  getRandomArray: getRandomArray,
  shuffleArray: shuffleArray,
}
export default ArrayUtil
